import React from 'react';
import ReactDOM from 'react-dom';
import cancelEvent from '../../../services/mini/cancelEvent';
import PopupService from '../../../services/PopupService';

class OutsideClickPanel extends React.Component {

    componentDidMount() {
        PopupService.listenEscPressed(this.props.onOutsideClick);
    }

    componentDidUpdate(prevProps) {
        if (this.props.opened) {
            this.disableBackBtn();

        } else {
            document.removeEventListener('keyup', this.onKeyCb, false);
            this.enableBackBtn();
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutsideCb, true);
        PopupService.stopListenEscPressed(this.props.onOutsideClick);
        this.enableBackBtn();
    }

    getHeader = () => {
        return document.querySelector('.header-navigation');
    }

    disableBackBtn = () => {
        const backBtn = this.getHeader();
        if (backBtn) {
            backBtn.classList.add('skip-click');
        }
    }

    enableBackBtn = () => {
        const backBtn = this.getHeader();
        if (backBtn) {
            backBtn.classList.remove('skip-click');
        }
    }

    _close(e) {
        if (!this.props.opened) return;

        const domNode = ReactDOM.findDOMNode(this);
        const clickedEl = e.target;

        if ((!domNode || !domNode.contains(clickedEl) || (clickedEl.className && clickedEl.className.indexOf && clickedEl.className.indexOf(this.props.classes) > -1))) {
            this.props.onOutsideClick(e);
        }
    }

    render() {
        return (
            <div className={this.props.classes}>
                {this.props.children}
            </div>
        );
    }
}

export default OutsideClickPanel;
